// extracted by mini-css-extract-plugin
module.exports = {"content":"_3U6rk3xPe_0UqCTdi8nCpS","vertical":"_3iOyB33B6ruo7I3XU43fkP","center":"_2TKh6DINBZ0envaeErtFQt","right":"WyvldHNvfWEoaU1NPK7aJ","left":"_239Sosha6oYWtpTrQDS7LD"};